App.SmHintComponent = Em.Component.extend Em.I18n.TranslateableProperties,
  tagName: 'span'
  classNames: ['sm-hint']
  classNameBindings: ['placementClass', 'isEmpty', 'whiteSpaceClass']
  attributeBindings: ['data-hint']
  hint: Em.computed.alias('data-hint')

  isEmpty: (->
    Em.isEmpty(@get('hint'))
  ).property('hint')

  placement: 'top'
  pre: false

  placementClass: (->
    'placement-' + @get('placement')
  ).property('placement')

  whiteSpaceClass: (->
    return '' unless @get('pre')
    'white-space-pre'
  ).property('pre')
